import { put } from 'redux-saga/effects';
import * as actions from '../actions';
import * as uploadFiles from '../uploadFile';



export function* uploadFileSaga(action) {
    try {
        const response = uploadFiles.uploadFiles(action.file, action.source)
        const supFile = {
            storageKeyFileName: response.data.data.storageKey,
            storageDisplayName: response.data.data.displayName,
            fileType: action.file.type
        };
        if (action.docType === 'LICENSE') {
            yield put({ type: actions.onUpdateLicenseFiles(supFile) });
        } else {
            yield put({ type: actions.onUpdateEmployementFiles(supFile) });
        }
    } catch (error) {
        yield put({ type: actions.onUploadFileFailed(error.response.data) });
    }
}
